<nz-skeleton [nzLoading]="loading">
</nz-skeleton>

<iframe #iframeCtrl *ngIf="src" style="width: 100%;height: 99%;" [src]="src" frameborder="0"></iframe>